import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-29">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[var(--forge-black)] via-[var(--forge-charcoal)] to-[var(--forge-black)]" data-id="element-30">
        <motion.div className="absolute inset-0 opacity-30" animate={{
        background: ['radial-gradient(circle at 20% 50%, var(--forge-lava) 0%, transparent 50%)', 'radial-gradient(circle at 80% 50%, var(--forge-lava) 0%, transparent 50%)', 'radial-gradient(circle at 50% 80%, var(--forge-lava) 0%, transparent 50%)', 'radial-gradient(circle at 20% 50%, var(--forge-lava) 0%, transparent 50%)']
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-31" />
      </div>

      {/* Geometric accent lines */}
      <div className="absolute inset-0 opacity-10" data-id="element-32">
        <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-[var(--forge-lava)] to-transparent" data-id="element-33" />
        <div className="absolute bottom-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-[var(--forge-lava)] to-transparent" data-id="element-34" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-36">
          <motion.h1 className="text-6xl md:text-8xl lg:text-9xl font-black tracking-tighter leading-none mb-6" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-37">
            YOU ARE <span className="text-[var(--forge-lava)]" data-id="element-38">FORGED</span>,
            <br data-id="element-39" />
            NOT FOUND.
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-[var(--forge-gray)] max-w-3xl mx-auto mb-12 leading-relaxed" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-40">
            The Forge is where discipline, pressure, leadership, and opportunity
            collide to shape high-performance careers.
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-4 justify-center items-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-41">
            <Button size="lg" onClick={() => document.getElementById('what')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-42">
              ENTER THE FORGE
            </Button>
            <Button size="lg" variant="secondary" onClick={() => document.getElementById('paths')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-43">
              LEARN MORE
            </Button>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-44">
        <ChevronDownIcon className="w-8 h-8 text-[var(--forge-lava)]" data-id="element-45" />
      </motion.div>
    </section>;
}